<template>
  <div class="error-container">
    <div class="error-content">
      <div class="error-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <path d="M16 16s-1.5-2-4-2-4 2-4 2"></path>
          <line x1="9" y1="9" x2="9.01" y2="9"></line>
          <line x1="15" y1="9" x2="15.01" y2="9"></line>
        </svg>
      </div>
      <h1 class="error-code">404</h1>
      <h2 class="error-title">Page Not Found</h2>
      <p class="error-description">
        The page you're looking for doesn't exist or has been moved. Let's get you back on track.
      </p>
      <div class="error-actions">
        <router-link to="/" custom v-slot="{ navigate }">
          <MaterialButton @click="navigate" color="success" variant="gradient">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="me-2">
              <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
            </svg>
            Go Home
          </MaterialButton>
        </router-link>
        <MaterialButton @click="goBack" color="success" variant="outline">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="me-2">
            <line x1="19" y1="12" x2="5" y2="12"></line>
            <polyline points="12 19 5 12 12 5"></polyline>
          </svg>
          Go Back
        </MaterialButton>
      </div>
    </div>
  </div>
</template>

<script>
import MaterialButton from "@/components/common/MaterialButton.vue";

export default {
  name: 'NotFound',
  components: {
    MaterialButton
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
}
</script>

<style scoped>
.error-container {
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.error-content {
  background: white;
  border-radius: 16px;
  padding: 60px 40px;
  max-width: 500px;
  width: 100%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.error-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 24px;
  color: #6c757d;
}

.error-icon svg {
  width: 100%;
  height: 100%;
}

.error-code {
  font-size: 72px;
  font-weight: 800;
  color: #6c757d;
  margin: 0 0 16px;
  line-height: 1;
}

.error-title {
  font-size: 28px;
  font-weight: 700;
  color: #1a202c;
  margin: 0 0 16px;
}

.error-description {
  font-size: 16px;
  color: #718096;
  line-height: 1.6;
  margin: 0 0 32px;
}

.error-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
}

@media (max-width: 480px) {
  .error-content {
    padding: 40px 24px;
  }
  
  .error-code {
    font-size: 56px;
  }
  
  .error-title {
    font-size: 24px;
  }
  
  .error-actions {
    flex-direction: column;
  }
}
</style>